import { PaymentFragment } from 'pages/Quote/Payment/PaymentDetail';
import { QuoteData } from 'pages/Quote/QuoteData';


export const paymentURLFor = (quoteData: QuoteData, fragment: PaymentFragment): string => {
  return `/quote/${quoteData.public_id}/${fragment}`;
};
